import { render } from "./PWAInstallPrompt.vue?vue&type=template&id=94c1097c&scoped=true"
import script from "./PWAInstallPrompt.vue?vue&type=script&lang=js"
export * from "./PWAInstallPrompt.vue?vue&type=script&lang=js"

import "./PWAInstallPrompt.vue?vue&type=style&index=0&id=94c1097c&scoped=true&lang=css"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94c1097c"],['__file',"PWAInstallPrompt.vue"]])

export default __exports__